<template>
	<div class="singleSiteOut">
		<!-- 站点 -->
		<Center/>
    <Left></Left>
		<Right></Right>
	</div>
</template>
<script>
// import { formatTime } from '../utils/index.js'
import Left from "@/components/pcsingleSite/left.vue";
import Center from "@/components/pcsingleSite/center.vue";
import Right from "@/components/pcsingleSite/right.vue";
export default {
  data () {
    return {
			
    };
  },
  components: {
    Left,
    Center,
    Right
  },
	mounted() {
    //事件公交总线
    if(this.$route.query&&this.$route.query.stationId){
      this.$EventBus.$emit('update',{ stationId: this.$route.query.stationId});
    }
	},
};
</script>

<style lang="scss" scoped>

</style>